import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, CardHeader, CardContent } from "@shadcn/components/ui/card";

import { cva } from "class-variance-authority"; 
import {  CalendarDays,  Truck, CheckCircle2, Store ,User, Package, Clock} from "lucide-react"; 
import { Badge } from "@shadcn/components/ui/badge";


import { useTaskCard } from "@zustand/useTaskCard";
import { useEffect } from "react";





export function TaskCard({ task, isOverlay }) {
    
    const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
        id: task.id, 
        data: {
            type: "Task",
            task, 
        },
        attributes: {
            roleDescription: "Task",
        },
    });

    const selectedCard = useTaskCard ((state) => state.selectedCard);
    const selected = useTaskCard((state => state.selected))
    const taskCard  = useTaskCard((state => state.task))
    const setSelected = useTaskCard((state => state.setSelected))
    useEffect(() => {
        if(task.selected) {
            if(selected === undefined) {
                selectedCard({...task})
                setSelected(true)
            }
        }
    },[])
    
    const style = {
        transition, 
        transform: CSS.Translate.toString(transform),
     
      };

      const cardClass = task?.id === taskCard?.id
        ? "border-2 border-gray-900 shadow-lg bg-gray-100"
        : "bg-white border border-gray-200 shadow-sm hover:shadow-md hover:border-gray-300";

   
    const variants = cva("", {
        variants: {
            dragging: {
                over: "ring-2 opacity-30", 
                overlay: "ring-2 ring-gray-400",
            },
        },
    });
   

    const formattedDateNeeded = task.dateNeeded ? new Date(task.dateNeeded).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }) : '';

    

    return (
        <Card
            onClick={() => {
                selectedCard(task)
                setSelected(true)
            }}
            ref={setNodeRef}
            style={style}
            className={`${cardClass} cursor-pointer ${variants({
                dragging: isOverlay ? "overlay" : isDragging ? "over" : undefined,
            })} transition-all duration-300 rounded-lg border-l-4 border-gray-700 relative max-w-[320px] hover:border-l-gray-900`}
        >
            <CardHeader 
                {...attributes}
                {...listeners}
                className="px-4 py-3 flex flex-row items-center justify-between border-b cursor-grab bg-gradient-to-r from-gray-50 to-gray-100"
            >
                <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <Store className="h-4 w-4 text-gray-600" />
                        <span className="font-semibold text-sm text-gray-900">
                            {task.store?.display_name}
                        </span>
                        <span className="text-xs text-gray-400">•</span>
                        <span className="text-xs text-gray-600 font-medium">{task.staffName}</span>
                    </div>

                    {task.customerName && (
                        <div className="flex items-center gap-2 text-sm">
                            <User className="h-4 w-4 text-gray-500" />
                            <span className="font-medium text-gray-800">{task.customerName}</span>
                        </div>
                    )}

                    {task.batchCode && (
                        <div className="flex items-center gap-2">
                            <Package className="h-4 w-4 text-gray-600" />
                            <span className="text-xs text-gray-700 font-medium">
                                Batch: {task.batchCode}
                            </span>
                        </div>
                    )}

                    <div className="flex items-center gap-2 flex-wrap">
                        {task?.order?.name && 
                        <Badge variant="outline" className="text-xs py-0.5 px-2 border-gray-300 bg-gray-100 text-gray-700">
                            {task?.order?.name}
                        </Badge>
                        }
                        {!task?.hasOrder && (
                            <>
                            {task?.orderNumber && <Badge variant="outline" className="text-xs bg-gray-100 text-gray-800">
                                {task?.orderNumber}
                            </Badge>}
                            <Badge variant="outline" className="text-xs bg-gray-100 text-gray-800">
                                Pre 2020
                            </Badge>
                            </>
                        )}
                       
                        {task.completed && (
                            <CheckCircle2 className="h-4 w-4 text-gray-900" />
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {task.toBeShipped && <Truck className="h-5 w-5 text-gray-600" />}
                    {task.fulfilled && <CheckCircle2 className="h-5 w-5 text-gray-900" />}
                </div>
            </CardHeader>

            <CardContent className="p-4 space-y-3">
                {/* Item Repairs với delivery options */}
                {task.itemRepairs?.length > 0 && (
                    <div className="space-y-2">
                        <div className="flex items-center gap-2 mb-2">
                            <Package className="h-4 w-4 text-gray-600" />
                            <span className="text-sm font-medium text-gray-700">Repair Items</span>
                        </div>
                        
                        {task.itemRepairs.map((repair, index) => (
                            <div key={index} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                                <div className="flex items-center justify-between mb-2">
                                    <Badge variant="outline" className="text-xs py-1 px-2 bg-white font-medium">
                                        {repair.sku}
                                    </Badge>
                                    
                                    
                                    <div className="flex items-center gap-2">
                                        {repair.toBeShipped ? (
                                            <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded-full">
                                                <Truck className="h-3 w-3 text-gray-600" />
                                                <span className="text-xs text-gray-700 font-medium">Ship</span>
                                            </div>
                                        ) : repair.pickupLocation ? (
                                            <div className="flex items-center gap-1 bg-gray-200 px-2 py-1 rounded-full">
                                                <Store className="h-3 w-3 text-gray-700" />
                                                                                <span className="text-xs text-gray-800 font-medium">
                                    {repair.pickupLocation?.display_name}
                                </span>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                
                                
                                {repair.dateNeededBy && (
                                    <div className="flex items-center gap-1 text-xs text-gray-600 mt-2">
                                        <Clock className="h-3 w-3" />
                                        <span>Needed by: </span>
                                        <span className="font-medium">
                                            {new Date(repair.dateNeededBy).toLocaleDateString('en-AU', {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                            })}
                                        </span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                
                <div className="flex items-center justify-between text-xs text-gray-600 border-t pt-3">
                    <div className="flex flex-col gap-1">
                        {task.dateNeeded && (
                            <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                                <CalendarDays className="h-3.5 w-3.5 text-gray-500" />
                                <span>Due:</span>
                                <span className="font-medium">{formattedDateNeeded}</span>
                            </div>
                        )}
                    </div>
                    
                    {task.additionalNotes && (
                        <div 
                            className="relative group max-w-[120px] truncate text-gray-500 hover:text-gray-700 cursor-help"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <span className="border-b border-dashed border-gray-300">
                                {task.additionalNotes?.length > 20 
                                    ? `${task.additionalNotes?.substring(0, 20)}...`
                                    : task.additionalNotes}
                            </span>
                            <div className="hidden group-hover:block absolute bottom-full right-0 bg-white p-3 text-xs rounded-lg shadow-lg border border-gray-200 max-w-[220px] break-words z-50">
                                <div className="font-medium text-gray-700 mb-1">Additional Notes:</div>
                                <div className="text-gray-600">{task.additionalNotes}</div>
                            </div>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
